import React, { useEffect, useState } from "react";
import { Users, CheckCircle, Calendar, TrendingUp, Ticket, Clock } from "lucide-react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

const cardBase =
  "rounded-xl p-5 flex flex-col gap-3 border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] hover:shadow-[0_0_20px_#00ff9044] transition-shadow col-span-2";

const KpiTile = ({ icon: Icon, value, label }) => (
  <div
    className="flex flex-col items-center justify-center gap-2 rounded-[10px] border border-white/10 bg-white/[0.03] p-4 text-center"
  >
    <Icon size={20} className="text-[#00ff90]" />
    <span className="text-2xl font-bold text-white leading-none">{value}</span>
    <span className="text-xs text-white/50">{label}</span>
  </div>
);

const InsightsAnalyticsPanel = ({ managerId }) => {
  const [kpis, setKpis] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`${API_BASE}/api/manager/analytics?manager_id=${managerId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => { if (!res.ok) throw new Error("Failed to load analytics"); return res.json(); })
      .then((data) => setKpis(data?.data || data || null))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [managerId]);

  const tiles = kpis ? [
    { icon: Users,        value: kpis.headcount ?? 0,         label: "Team Size" },
    { icon: CheckCircle,  value: kpis.present_today ?? 0,     label: "Present Today" },
    { icon: Calendar,     value: kpis.on_leave_today ?? 0,    label: "On Leave Today" },
    { icon: TrendingUp,   value: typeof kpis.avg_performance === "number" && kpis.avg_performance > 0 ? kpis.avg_performance.toFixed(1) : "—", label: "Avg Performance" },
    { icon: Ticket,       value: kpis.open_tickets ?? 0,      label: "Open Tickets" },
    { icon: Clock,        value: kpis.pending_approvals ?? 0, label: "Pending Approvals" },
  ] : [];

  return (
    <div className={cardBase}>
      <div className="flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest">Insights & Analytics</span>
        <span className="text-2xl">📊</span>
      </div>

      {loading && <p className="text-white/20 text-sm animate-pulse">Loading...</p>}
      {error && <p className="text-red-400 text-sm">⚠ {error}</p>}

      {!loading && !error && !kpis && (
        <p className="text-white/20 text-sm">No analytics data available.</p>
      )}

      {!loading && !error && kpis && (
        <div className="grid grid-cols-3 gap-3">
          {tiles.map((t, i) => (
            <KpiTile key={i} icon={t.icon} value={t.value} label={t.label} />
          ))}
        </div>
      )}
    </div>
  );
};

export default InsightsAnalyticsPanel;
